import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const Companies = React.lazy(() => import('./index'));
const CompanyTable = React.lazy(() => import('./companyTable'));
const Company = React.lazy(() => import('./company'));
const CompanyDetail = React.lazy(() => import('./companyDetail'));
const AddNewCompany = React.lazy(() => import('./addNewCompany'));
const EditCompany = React.lazy(() => import('./editCompany'));

export const useCompanyRoutes = () => {

    return (
        <Route path="companies" element={<Suspense fallback={<div>منتظر باشید...</div>}><Companies /></Suspense>} >
            <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><CompanyTable/></Suspense> } />
            <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewCompany/></Suspense> } />
            <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><Company/></Suspense> } >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><CompanyDetail/></Suspense> } />
                <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditCompany/></Suspense> } />
            </Route>
        </Route>
    )
}